"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _MultiselectDropdown = _interopRequireDefault(require("../../../components/MultiselectDropdown/MultiselectDropdown"));
var _utils = require("./utils");
var _useBreakPoint = require("../../../common/useBreakPoint");
var _ShowMoreItems = _interopRequireDefault(require("./ShowMore/ShowMoreItems"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
(function () {
  const styles = ".filters-container {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(114px, 1fr));\n  justify-content: center;\n  gap: 15px; }\n  .filters-container .bx--list-box__menu {\n    width: var(--options_width); }\n  .filters-container .filter-container:last-of-type .bx--list-box__menu {\n    left: calc(var(--options_width) * -1 --options_width - 14px); }\n";
  const fileName = "FilterArea_FilterArea";
  const element = document.querySelector("style[data-sass-component='FilterArea_FilterArea']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
function FilterArea(_ref) {
  let {
    initialFilters,
    onFiltersUpdate,
    translate
  } = _ref;
  const [filterAreaState, setFilterAreaState] = (0, _react.useState)(initialFilters);
  const [shouldUpdateFilters, setShouldUpdateFilters] = (0, _react.useState)(false);
  const [filtersChanged, setFiltersChanged] = (0, _react.useState)(false);
  const [shouldShowAllFilters, setShouldShowAllFilters] = (0, _react.useState)(false);
  const {
    isDesktop,
    isTablet,
    isMobile
  } = (0, _useBreakPoint.useBreakPoint)();
  const isSmallDispaly = isTablet || isMobile;
  const filterRef = (0, _react.useRef)(null);
  const DEFAULT_FILTER_WIDTH = 114;
  const [optionsWidth, setOptionsWidth] = (0, _react.useState)(DEFAULT_FILTER_WIDTH);
  (0, _react.useEffect)(() => {
    const propsDerivedState = (0, _utils.getDerivedStateFromInitialFilters)(initialFilters);
    setFilterAreaState(propsDerivedState);
  }, [initialFilters]);
  (0, _react.useEffect)(() => {
    if (shouldUpdateFilters && filtersChanged) {
      onFiltersUpdate(filterAreaState, setFilterAreaState);
      setShouldUpdateFilters(false);
      setFiltersChanged(false);
    }
  }, [shouldUpdateFilters, filtersChanged, onFiltersUpdate, filterAreaState]);
  (0, _react.useLayoutEffect)(() => {
    if (filterRef.current) {
      let computedWidth = filterRef.current.clientWidth * 2 + 14;
      setOptionsWidth(computedWidth);
    }
  }, [filterRef.current]);
  const inlineStyles = {};
  if (isSmallDispaly) {
    const SMALL_DISPALYS_FILTER_WIDTH = '288px';
    inlineStyles.gridTemplateColumns = SMALL_DISPALYS_FILTER_WIDTH;
  }
  if (isDesktop) {
    inlineStyles['--options_width'] = `${optionsWidth}px`;
  }
  return /*#__PURE__*/_react.default.createElement("div", _extends({
    className: "filters-container"
  }, Object.keys(inlineStyles).length > 0 && {
    style: inlineStyles
  }), filterAreaState.slice(0, isSmallDispaly && !shouldShowAllFilters ? 4 : filterAreaState.length).map((filter, id) => /*#__PURE__*/_react.default.createElement("div", _extends({
    className: "filter-container",
    key: id
  }, id === 0 && {
    ref: filterRef
  }), /*#__PURE__*/_react.default.createElement(_MultiselectDropdown.default, _extends({
    id: id.toString()
  }, filter, {
    toggle: () => {
      if (filtersChanged) {
        setShouldUpdateFilters(true);
      }
      (0, _utils.toggleFilter)(filter.id, setFilterAreaState);
    },
    onClickItem: (event, item) => {
      (0, _utils.onItemClick)(item, filter, setFilterAreaState, setShouldUpdateFilters, setFiltersChanged);
    }
  })))), isSmallDispaly && filterAreaState.length > 4 && /*#__PURE__*/_react.default.createElement(_ShowMoreItems.default, {
    showMore: shouldShowAllFilters,
    setShowMore: setShouldShowAllFilters,
    translate: translate
  }));
}
FilterArea.propTypes = {
  initialFilters: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.string,
    label: _propTypes.default.string,
    itmes: _propTypes.default.arrayOf(_propTypes.default.shape({
      id: _propTypes.default.number,
      name: _propTypes.default.string,
      active: _propTypes.default.bool,
      disabled: _propTypes.default.bool
    }))
  })),
  onFiltersUpdate: _propTypes.default.func,
  translate: _propTypes.default.func
};
var _default = exports.default = FilterArea;